import { type CSSProperties, type PropsWithChildren } from "react";

export function RootMain(props: PropsWithChildren) {
  return (
    <main
      className="w-full h-full"
      style={
        {
          "--sztama-auth-navigation-height": 0,
        } as CSSProperties
      }
    >
      {props.children}
    </main>
  );
}
